export default __webpack_public_path__ + "media/images/front/municipality_collaboration/betsukai/ogp-eaee440969916d4e93f3e077456b423e.png";